/* eslint-disable */
import { useEffect, useState } from "react";
import api from "../api/PosApi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DataTable from "react-data-table-component";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";

const MySwal = withReactContent(Swal);

export default function Historial() {
    const [documentos, setDocumentos] = useState<any[]>([]);
    const [desde, setDesde] = useState("");
    const [hasta, setHasta] = useState("");
    const [tipo, setTipo] = useState("");
    const [estado, setEstado] = useState("");
    const [cargando, setCargando] = useState(false);

    const buscar = async () => {
        try {
            setCargando(true);
            let query = "?";
            if (desde) query += `desde=${desde}&`;
            if (hasta) query += `hasta=${hasta}&`;
            if (tipo) query += `tipo=${tipo}&`;

            const res = await api.get(`/pos/ventas/filtro${query}`);
            let data = res.data;

            if (estado) data = data.filter((d: any) => d.estadoMH === estado);
            if (tipo) data = data.filter((d: any) => d.tipoDte === tipo);

            setDocumentos(data);
        } catch {
            MySwal.fire("Error", "❌ No se pudieron cargar los documentos", "error");
        } finally {
            setCargando(false);
        }
    };

    const verJSON = (doc: any) => {
        MySwal.fire({
            title: `Documento ${doc.tipoDte}`,
            html: `<pre style="text-align:left; max-height:60vh; overflow:auto; background:#111; color:#00ffcc; padding:10px; border-radius:8px;">${JSON.stringify(
                doc,
                null,
                2
            )}</pre>`,
            width: "70%",
            confirmButtonText: "Cerrar",
            background: "#0d0d0d",
            color: "#fff",
        });
    };

    const descargarPDF = async (codigo: any) => {
        try {
            console.log(codigo);
            const res = await api.get(`/pos/ventas/${codigo}/pdf`, {
                responseType: "blob"
            });

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${codigo}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            MySwal.fire("Error", "❌ No se pudo descargar el PDF", "error");
        }
    };

    const descargarJSON = async (codigo: any) => {
        try {
            const res = await api.get(`/pos/ventas/${codigo}/json`, {
                responseType: "blob"
            });

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${codigo}.json`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            MySwal.fire("Error", "❌ No se pudo descargar el JSON", "error");
        }
    };

    const descargarJSONVentas = async () => {
        try {
            const res = await api.get(`/pos/ventas/${desde}/${hasta}/reporte`, {
                responseType: "blob"
            });

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Reporte-Ventas-${desde}-${hasta}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            MySwal.fire("Error", "❌ No se pudo descargar el PDF", "error");
        }
    };

    const columnas = [
        {
            name: "Fecha",
            selector: (row: any) => new Date(row.fechaEmision).toLocaleDateString(),
            sortable: true,
            width: "120px",
        },
        { name: "Cliente", selector: (row: any) => row.clienteNombre, sortable: true },
        {
            name: "Tipo DTE",
            selector: (row: any) =>
                row.tipoDte === "01"
                    ? "Factura"
                    : row.tipoDte === "03"
                        ? "Crédito Fiscal"
                        : row.tipoDte === "05"
                            ? "Nota de Crédito"
                            : row.tipoDte === "14"
                                ? "Sujeto Excluido"
                                : "",
            sortable: true,
        },
        {
            name: "Total",
            selector: (row: any) => `$${row.totalPagar.toFixed(2)}`,
            sortable: true,
            right: true,
        },
        { name: "Estado", selector: (row: any) => row.estadoMH, sortable: true },
        {
            name: "Acciones",
            cell: (row: any) => (
                <div className="">
                    {row.estadoMH === "ENVIADO" && (
                        <>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => descargarJSON(row.id)}
                            >
                                JSON
                            </button>

                            <button
                                className="btn btn-secondary btn-sm"
                                onClick={() => descargarPDF(row.id)}
                            >
                                PDF
                            </button>
                        </>
                    )}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        },
    ];

    const customStyles = {
        table: {
            style: { backgroundColor: "#121212" },
        },
        headCells: {
            style: {
                backgroundColor: "#1e1e1e",
                color: "#fff",
                fontWeight: "bold",
            },
        },
        rows: {
            style: {
                backgroundColor: "#181818",
                color: "#e0e0e0",
                "&:hover": { backgroundColor: "#222" },
                padding: "1rem"
            },
        },
        pagination: {
            style: {
                backgroundColor: "#121212",
                color: "#ccc",
            },
        },
    };

    return (
        <Container className="mt-4">
            <Card className="card-black">
                <Card.Header>
                    <h3 className="mb-0">Historial de Documentos</h3>
                </Card.Header>
                <Card.Body>
                    <Row className="mb-3">
                        <Col className="form-group">
                            <label>Desde:</label>
                            <input
                                type="date"
                                value={desde}
                                onChange={(e) => setDesde(e.target.value)}
                                className="form-control bg-dark text-light border-0"
                            />
                        </Col>
                        <Col className="form-group">
                            <label>Hasta:</label>
                            <input
                                type="date"
                                value={hasta}
                                onChange={(e) => setHasta(e.target.value)}
                                className="form-control bg-dark text-light border-0"
                            />
                        </Col>
                        <Col className="form-group">
                            <label>Tipo DTE:</label>
                            <select
                                value={tipo}
                                onChange={(e) => setTipo(e.target.value)}
                                className="form-select bg-dark text-light border-0"
                            >
                                <option value="">Todos</option>
                                <option value="01">Factura</option>
                                <option value="03">Comprobante Crédito Fiscal</option>
                                <option value="05">Nota de Crédito</option>
                                <option value="14">Factura Sujeto Excluido</option>
                            </select>
                        </Col>

                    </Row>

                    <Row>
                        <Col md={10}>
                            <label>Estado:</label>
                            <select
                                value={estado}
                                onChange={(e) => setEstado(e.target.value)}
                                className="form-select bg-dark text-light border-0"
                            >
                                <option value="">Todos</option>
                                <option value="CREADO">CREADO</option>
                                <option value="ENVIADO">ENVIADO</option>
                                <option value="ERROR_ENVIO">ERROR_ENVIO</option>
                                <option value="VOID-NO-H">INVALIDADO NO HACIENDA</option>
                                <option value="ANULADO">ANULADO</option>
                            </select>
                        </Col>
                        <Col className="text-end">
                            <Button
                                onClick={buscar}
                                variant="success"
                                className="w-100 h-100"
                            >
                                Buscar
                            </Button>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <Button
                                onClick={descargarJSONVentas}
                                variant="primary"
                                className="w-100 h-100"
                            >
                                Generar Reporte de Ventas
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card
                className="card-black"
                style={{ backgroundColor: "#1a1a1a", color: "#e0e0e0" }}
            >
                <Card.Body>
                    {cargando ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" variant="light" />
                            <p className="mt-3">Cargando documentos...</p>
                        </div>
                    ) : (
                        <DataTable
                            columns={columnas}
                            data={documentos}
                            pagination
                            highlightOnHover
                            dense
                            customStyles={customStyles}
                            fixedHeader
                            fixedHeaderScrollHeight="500px"
                            noDataComponent="No se encontraron documentos"
                            paginationPerPage={8}
                            paginationRowsPerPageOptions={[5, 8, 15, 25]}
                        />
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
}
